module.exports = __webpack_public_path__ + "img/kyte-thumb.1bd2c638.jpg";